import moment from 'moment';
import i18n from './i18n';

moment.locale(i18n.language || 'es');
